import { render } from "./AssignmentCardWithDraftDate.vue?vue&type=template&id=640291df&scoped=true"
import script from "./AssignmentCardWithDraftDate.vue?vue&type=script&lang=js"
export * from "./AssignmentCardWithDraftDate.vue?vue&type=script&lang=js"

import "./AssignmentCardWithDraftDate.vue?vue&type=style&index=0&id=640291df&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640291df"]])

export default __exports__